<template>
	<div id='setTopSpec'>
		<div>当前使用中的热门规格</div>
		<div v-if="app_info.hot_spec_ids.length>0">
			<div v-for="(item,index) in app_info.hot_specs" :key="index" class="exist-top-spec">
				<div class="exist-top-spec-name">{{item.name}}</div>
				<el-button type="danger" @click='deleteTopSpec(index)'>删除</el-button>
				<el-button @click="moveUp(index)">上移</el-button>
				<el-button @click="moveDown(index)">下移</el-button>
			</div>
		</div>
		<div v-else>
			<div>无</div>
		</div>
		<el-button v-if="app_info.hot_spec_ids.length<3" type="primary" @click="openAddDialog">添加</el-button>
		<el-dialog :visible.sync="showAddDialog" title='搜索添加规格' width="80%">
			<SpecSearch v-on:specChosen="onSpecChosen"></SpecSearch>
		</el-dialog>
	</div>
</template>

<script>
import {
	mapState,mapActions
} from "vuex";
import SpecSearch from "../components/SpecSearch.vue"
import {
	modifyApp
} from "../api/index.js"	
export default {
	data() {
		return {
			showAddDialog:false
		}
	},
	components:{
		SpecSearch
	},
	computed:{
		...mapState([
			"app_info"
		]),
		// hot_spec_info(){
			
		// }
	},
	methods:{
		openAddDialog:function(){
			this.showAddDialog = true
		},
		onSpecChosen:function(e){
			this.app_info.hot_spec_ids.push(e.spec_id);
			this.modifyUniformly();
		},
		moveUp:function(index){
			if(index>0){
				[this.app_info.hot_spec_ids[index-1],this.app_info.hot_spec_ids[index]] = [this.app_info.hot_spec_ids[index],this.app_info.hot_spec_ids[index-1]];
			}
			this.modifyUniformly();
		},
		moveDown:function(index){
			if(index<2){
				[this.app_info.hot_spec_ids[index],this.app_info.hot_spec_ids[index+1]] = [this.app_info.hot_spec_ids[index+1],this.app_info.hot_spec_ids[index]];
			}
			this.modifyUniformly();
		},
		deleteTopSpec:function(index){
			this.app_info.hot_spec_ids.splice(index,1);
			this.modifyUniformly();
		},
		...mapActions([
			"getAppInfoFromServer"
		]),
		modifyUniformly:function(){
			modifyApp(this.app_info).then(res=>{
				console.log(res)
				if(res.data.code==200){
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.showAddDialog=false;
					this.getAppInfoFromServer().catch(err=>{
						console.log(err)
						this.$message.error('系统错误，请联系管理员')
					})
				}
			})
		}
	}
}
</script>

<style scoped="scoped">
	#setTopSpec{
		margin:30px 40px;
		box-shadow: 0px 4px 12px 0px rgba(66, 66, 66, 0.1);
		border-radius: 10px;
		padding:20px 80px;
		font-size: 16px;
		font-weight: bold;
		color: #4C4C4C;
	}
	.exist-top-spec{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-right: 50px;
	}
	.exist-top-spec-name{
		padding: 12px 20px;
		border: 1px solid gray;
		border-radius: 5px;
		margin-right: 5px;
	}
</style>
